// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:11-10-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/***************** FETCH ALL GROUP REPORT START *************** */
export const getAllGroupReport = (fetchData: any) => {
	const data = {
		GetAllGroupReportToken: fetchData,
	};
	const url = `${API_URL}fetchAllGroupReports`;
	return makeApiCall(url, data);
};
/***************** FETCH ALL GROUP REPORT END *************** */
